<script setup>
import { uploadPopulatedCsv, viewSalary } from '@/services/payroll.services';
import { requestClientResetPassword } from '@/services/auth.services';
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer';
import PayrollTable from '@/components/Payroll/PayrollTable.vue';
import PayrollElem from '@/components/Payroll/PayrollElem.vue';
import PayslipModal from '@/components/Payroll/PayslipModal.vue';
import PayrollSummary from '@/components/Payroll/PayrollSummary.vue';
export default {
    components: { PDFViewer, PayrollTable, PayrollElem, PayslipModal, PayrollSummary },
    data() {
        return {
            payroll_url: null,
            showPayroll: false,
            file: null,
            loadingStatus: false,
            employees: [],
            summary: null,
            tblColumns: [
                {
                    title: 'Name',
                    key: 'name',
                    sortable: true,
                    sortType: 'asc',
                    minWidth: 180,
                    sortMethod: (a, b, type) => {
                        if (type == 'asc') {
                            return a > b ? 1 : -1;
                        } else {
                            return a > b ? 1 : -1;
                        }
                    },
                    //fixed: 'left',
                },
                {
                    title: 'Gross Pay',
                    key: 'gross_pay',
                    width: 180,
                },
                {
                    title: 'Net Pay',
                    key: 'gross_pay',
                    width: 180,
                },
                {
                    title: 'Actions',
                    width: 150,
                    fixed: 'right',
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h(
                                'Icon',
                                {
                                    props: {
                                        type: 'ios-mail-open',
                                        size: '20',
                                    },
                                    on: {
                                        click: () => {
                                            console.log('test');
                                            this.handleViewingSalary(params.row);
                                            // this.handleViewPayslip(params.row);
                                        },
                                    },
                                },
                                'edit'
                            ),
                            h(
                                'Icon',
                                {
                                    props: {
                                        type: 'md-share-alt',
                                        size: 20,
                                    },
                                    on: {
                                        click: () => {
                                            requestClientResetPassword(params.row)
                                                .then((res) => {
                                                    if (res.data) {
                                                        this.$Message.success('Successfully Send Email');
                                                    }
                                                })
                                                .catch(() => {
                                                    this.$Message.error('Failed to Send Email');
                                                });
                                        },
                                    },
                                },
                                'send-invite-email'
                            ),
                        ]);
                    },
                },
            ],
        };
    },
    methods: {
        async upload() {
            try {
                this.loadingStatus = true;
                const { data } = await uploadPopulatedCsv({ file: this.file });
                console.log('data: ', data);
                this.employees = data.data;
                this.summary = data.total;
                this.file = null;
                this.loadingStatus = false;
                this.$Message.success('Success');
            } catch (err) {
                this.$Message.err(err);
            }
        },
        async handleOnUpload(file) {
            this.file = file;
        },
        async handleViewingSalary(data) {
            console.log('fetching salary: ', data);
            viewSalary({ ...data, user: JSON.parse(data.id), date: '2025-01-01', basic_pay: 41250 }).then(
                (response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    // console.log('url: ', url)
                    // const link = document.createElement('a');
                    // link.href = url;
                    // link.setAttribute('download', 'file.pdf'); //or any other extension
                    // document.body.appendChild(link);
                    // link.click();
                    this.showPayroll = true;
                    this.payroll_url = url;
                }
            );
        },
        async handleViewSalary(data) {
            this.$refs.payrollElem.handleViewSalary(data);
        },
        async handleSendSalary(data) {
            this.$refs.payrollElem.handleSendSalary(data);
        },
        async handleViewPayslip(data) {
            this.$refs.payslipModal.handleViewSalary(data);
        },
    },
};
</script>

<template>
    <div>
        <p>Click on import CSV to get started</p>
        <Upload action="//jsonplaceholder.typicode.com/posts/" :before-upload="handleOnUpload">
            <Button icon="ios-cloud-upload-outline">Upload CSV</Button>
        </Upload>
        <div v-if="file !== null">
            Upload file: {{ file.name }}
            <Button type="primary" :loading="loadingStatus" @click="upload">{{
                loadingStatus ? 'Uploading' : 'Click to upload'
            }}</Button>
        </div>
        <div v-if="employees.length > 0">
            <PayrollSummary :summary="summary"></PayrollSummary>
            <PayrollTable
                :data="employees"
                @handleViewSalary="handleViewSalary"
                @handleSendSalary="handleSendSalary"
            ></PayrollTable>
            <PayrollElem ref="payrollElem"></PayrollElem>
            <PayslipModal ref="payslipModal" />
        </div>
    </div>
</template>

<style scoped lang="scss"></style>
